import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Minus, Plus, ArrowRight, ChevronDown, ArrowLeft } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { ValuePropositionBanner, Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { openWhatsApp, WHATSAPP_MESSAGES } from '../utils/whatsapp';

// Product Images
const PRODUCT_IMAGES = {
  'bpc-157': {
    main: '/images/bpc-157/bpc-vial.png',
    gallery: [
      '/images/bpc-157/bpc-vial.png',
      '/images/bpc-157/bpc-boxvial.png',
      '/images/bpc-157/bpc-side.png',
      '/images/bpc-157/bpc-info.png',
    ]
  },
  'ghk-cu': {
    main: '/images/ghk-cu/ghk-cu-50-main.png',
    gallery: [
      '/images/ghk-cu/ghk-cu-50-main.png',
      '/images/ghk-cu/ghk-cu-50-boxvial.png',
      '/images/ghk-cu/ghk-cu-50-side.png',
      '/images/ghk-cu/ghk-cu-50-info.png'
    ],
    variants: {
      '50mg': [
        '/images/ghk-cu/ghk-cu-50-main.png',
        '/images/ghk-cu/ghk-cu-50-boxvial.png',
        '/images/ghk-cu/ghk-cu-50-side.png',
        '/images/ghk-cu/ghk-cu-50-info.png'
      ],
      '10mg': [
        '/images/ghk-cu/ghk-cu-10-main.png',
        '/images/ghk-cu/ghk-cu-10-boxvial.png',
        '/images/ghk-cu/ghk-cu-10-side.png',
        '/images/ghk-cu/ghk-cu-10-info.png'
      ]
    }
  },
  'nad-plus': {
    main: '/images/nad-plus/nad-vial.png',
    gallery: [
      '/images/nad-plus/nad-vial.png',
      '/images/nad-plus/nad-alt.png',
      '/images/nad-plus/nad-box.png',
      '/images/nad-plus/nad-info.png'
    ]
  },
  'diet-fuel-cocoa': {
    main: '/images/diet-fuel-cocoa/main.png',
    gallery: [
      '/images/diet-fuel-cocoa/main.png',
      '/images/diet-fuel-cocoa/flat.png',
      '/images/diet-fuel-cocoa/side.png',
      '/images/diet-fuel-cocoa/back.png'
    ]
  },
  'diet-fuel-coconut': {
    main: '/images/diet-fuel-coconut/main.png',
    gallery: [
      '/images/diet-fuel-coconut/main.png',
      '/images/diet-fuel-coconut/flat.png',
      '/images/diet-fuel-coconut/side.png',
      '/images/diet-fuel-coconut/back.png'
    ]
  },
  'tb500': {
    main: '/images/tb500/tb500-vial.png',
    gallery: [
      '/images/tb500/tb500-vial.png',
      '/images/tb500/tb500-box.png',
      '/images/tb500/tb500-alt.png',
      '/images/tb500/tb500-info.png'
    ]
  },
  'magnesium-glycinate': {
    main: '/images/magnesium/mag-main.png',
    gallery: [
      '/images/magnesium/mag-main.png',
      '/images/magnesium/mag-info.png',
      '/images/magnesium/mag-certification.png',
      '/images/magnesium/mag-science.png'
    ]
  },
  'mots-c': {
    main: '/images/mots-c/mots-25-main.png',
    gallery: [
      '/images/mots-c/mots-25-main.png',
      '/images/mots-c/mots-25-boxvial.png',
      '/images/mots-c/mots-25-side.png',
      '/images/mots-c/mots-25-info.png'
    ],
    variants: {
      '25mg': [
        '/images/mots-c/mots-25-main.png',
        '/images/mots-c/mots-25-boxvial.png',
        '/images/mots-c/mots-25-side.png',
        '/images/mots-c/mots-25-info.png'
      ],
      '10mg': [
        '/images/mots-c/mots-10-main.png',
        '/images/mots-c/mots-10-boxvial.png',
        '/images/mots-c/mots-10-side.png',
        '/images/mots-c/mots-10-info.png'
      ]
    }
  },
  'aod-9604': {
    main: '/images/aod-9604/aod-main.png',
    gallery: [
      '/images/aod-9604/aod-main.png',
      '/images/aod-9604/aod-boxvial.png',
      '/images/aod-9604/aod-side.png',
      '/images/aod-9604/aod-info.png'
    ]
  },
  'bioglutide': {
    main: '/images/bioglutide/bio-main.png',
    gallery: [
      '/images/bioglutide/bio-main.png',
      '/images/bioglutide/bio-boxvial.png',
      '/images/bioglutide/bio-side.png',
      '/images/bioglutide/bio-info.png'
    ]
  },
  'dsip': {
    main: '/images/dsip/dsip-main.png',
    gallery: [
      '/images/dsip/dsip-main.png',
      '/images/dsip/dsip-boxvial.png',
      '/images/dsip/dsip-side.png',
      '/images/dsip/dsip-info.png'
    ]
  },
  'kisspeptin': {
    main: '/images/kisspeptin/kiss-main.png',
    gallery: [
      '/images/kisspeptin/kiss-main.png',
      '/images/kisspeptin/kiss-boxvial.png',
      '/images/kisspeptin/kiss-side.png',
      '/images/kisspeptin/kiss-info.png'
    ]
  },
  'll-37': {
    main: '/images/ll-37/ll37-main.png',
    gallery: [
      '/images/ll-37/ll37-main.png',
      '/images/ll-37/ll37-boxvial.png',
      '/images/ll-37/ll37-side.png',
      '/images/ll-37/ll37-info.png'
    ]
  },
  'selank': {
    main: '/images/selank/selank-main.png',
    gallery: [
      '/images/selank/selank-main.png',
      '/images/selank/selank-boxvial.png',
      '/images/selank/selank-side.png',
      '/images/selank/selank-info.png'
    ]
  },
  'semax': {
    main: '/images/semax/semax-main.png',
    gallery: [
      '/images/semax/semax-main.png',
      '/images/semax/semax-boxvial.png',
      '/images/semax/semax-side.png',
      '/images/semax/semax-info.png'
    ]
  },
  'slu-pp-332': {
    main: '/images/slu-pp-332/slu-main.png',
    gallery: [
      '/images/slu-pp-332/slu-main.png',
      '/images/slu-pp-332/slu-boxvial.png',
      '/images/slu-pp-332/slu-side.png',
      '/images/slu-pp-332/slu-info.png'
    ]
  },
  'ss-31': {
    main: '/images/ss-31/ss31-main.png',
    gallery: [
      '/images/ss-31/ss31-main.png',
      '/images/ss-31/ss31-boxvial.png',
      '/images/ss-31/ss31-side.png',
      '/images/ss-31/ss31-info.png'
    ]
  },
  'vilon': {
    main: '/images/vilon/vilon-main.png',
    gallery: [
      '/images/vilon/vilon-main.png',
      '/images/vilon/vilon-boxvial.png',
      '/images/vilon/vilon-side.png',
      '/images/vilon/vilon-info.png'
    ]
  },
  'vip': {
    main: '/images/vip/vip-main.png',
    gallery: [
      '/images/vip/vip-main.png',
      '/images/vip/vip-boxvial.png',
      '/images/vip/vip-side.png',
      '/images/vip/vip-info.png'
    ]
  },
  'retatrutide': {
    main: '/images/retatrutide/reta-20-main.png',
    gallery: [
      '/images/retatrutide/reta-20-main.png',
      '/images/retatrutide/reta-20-boxvial.png',
      '/images/retatrutide/reta-20-side.png',
      '/images/retatrutide/reta-20-info.png'
    ],
    variants: {
      '20mg': [
        '/images/retatrutide/reta-20-main.png',
        '/images/retatrutide/reta-20-boxvial.png',
        '/images/retatrutide/reta-20-side.png',
        '/images/retatrutide/reta-20-info.png'
      ],
      '10mg': [
        '/images/retatrutide/reta-10-main.png',
        '/images/retatrutide/reta-10-boxvial.png',
        '/images/retatrutide/reta-10-side.png',
        '/images/retatrutide/reta-10-info.png'
      ]
    }
  },
  'revigen': {
    main: '/images/revigen/revigen-main.png',
    gallery: [
      '/images/revigen/revigen-main.png',
      '/images/revigen/revigen-boxvial.png',
      '/images/revigen/revigen-side.png',
      '/images/revigen/revigen-info.png'
    ]
  },
  'glow': {
    main: '/images/glow/glow-main.png',
    gallery: [
      '/images/glow/glow-main.png',
      '/images/glow/glow-boxvial.png',
      '/images/glow/glow-side.png',
      '/images/glow/glow-info.png'
    ]
  },
  'bpc157-tb500-tablets': {
    main: '/images/bpc157-tb500-tablets/main.png',
    gallery: [
      '/images/bpc157-tb500-tablets/main.png',
      '/images/bpc157-tb500-tablets/back.png',
      '/images/bpc157-tb500-tablets/side.png',
      '/images/bpc157-tb500-tablets/info.png'
    ]
  },
  'gnc-fish-oil': {
    main: '/images/gnc-fish-oil/main.png',
    gallery: [
      '/images/gnc-fish-oil/main.png',
      '/images/gnc-fish-oil/back.png',
      '/images/gnc-fish-oil/content.png',
      '/images/gnc-fish-oil/info.png'
    ]
  },
  'bac-water': {
    main: '/images/bac-water/main.png',
    gallery: [
      '/images/bac-water/main.png',
      '/images/bac-water/boxvial.png',
      '/images/bac-water/info.png'
    ]
  }
};

// Product Data
const PRODUCTS = {
  'bpc-157': {
    id: 'bpc-157',
    name: 'BPC-157',
    brand: 'Toro Pharma',
    price: '₹6,500',
    priceNum: 6500,
    inStock: true,
    description: `Peptides are short chains of amino acids that support biological signaling within the body. BPC-157 is associated with recovery, tissue repair, and gut health support.`,
    benefits: [
      'Supports recovery',
      'Reduces inflammation',
      'Supports gut health',
      'Aids regeneration'
    ],
    dosage: [
      'Based on individual biology',
      'Use under guidance'
    ],
    additionalInfo: {
      category: 'Peptide',
      form: 'Lyophilized'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500' }
    ]
  },
  'ghk-cu': {
    id: 'ghk-cu',
    name: 'GHK-Cu',
    brand: 'Toro Pharma',
    price: '₹12,000',
    priceNum: 12000,
    inStock: true,
    variants: [
      { key: '50mg', name: '50 mg', label: '50 mg', price: '₹12,000', priceNum: 12000 },
      { key: '10mg', name: '10 mg', label: '10 mg', price: '₹6,500', priceNum: 6500 }
    ],
    description: `GHK-Cu is a copper peptide known for its role in skin health and regeneration. It supports collagen synthesis and wound healing.`,
    benefits: [
      'Supports skin health',
      'Promotes collagen synthesis',
      'Aids wound healing',
      'Supports tissue repair'
    ],
    dosage: [
      'Based on individual biology',
      'Use under guidance'
    ],
    additionalInfo: {
      category: 'Peptide',
      form: 'Lyophilized'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'nad-plus': {
    id: 'nad-plus',
    name: 'NAD+',
    brand: 'Toro Pharma',
    price: '₹5,500',
    priceNum: 5500,
    inStock: true,
    description: `NAD+ (Nicotinamide Adenine Dinucleotide) is a critical coenzyme involved in cellular energy production and metabolic processes. It plays a key role in mitochondrial function, DNA repair, and healthy aging pathways.`,
    benefits: [
      'Supports cellular energy production',
      'Helps improve mitochondrial function',
      'Supports DNA repair mechanisms',
      'Enhances brain function and mental clarity',
      'Promotes healthy aging processes'
    ],
    dosage: [
      'Typical: 50–100 mg per day',
      'Frequency: Daily or alternate days',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      category: 'Longevity compound',
      form: 'Lyophilized',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'tb500': {
    id: 'tb500',
    name: 'TB500',
    brand: 'Toro Pharma',
    price: '₹7,000',
    priceNum: 7000,
    inStock: true,
    description: `TB500 is a synthetic peptide derived from thymosin beta-4, known for its role in tissue repair, cellular migration, and recovery processes. It supports healing, flexibility, and regeneration across muscle, tendon, and connective tissue systems.

Within structured protocols, TB500 is used to accelerate recovery, improve mobility, and support long-term biological repair.`,
    benefits: [
      'Supports tissue repair and regeneration',
      'Enhances recovery from physical stress',
      'Improves mobility and flexibility',
      'Supports muscle and connective tissue healing',
      'Aids anti-inflammatory response'
    ],
    dosage: [
      'Protocol-based usage',
      'Depends on recovery and performance goals',
      'Use under professional guidance'
    ],
    additionalInfo: {
      category: 'Peptide',
      form: 'Lyophilized',
      storage: 'Cool, dry place away from light'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'longevity-stack': {
    id: 'longevity-stack',
    name: 'Longevity Stack',
    brand: 'Life Reversal',
    price: '₹4,500',
    priceNum: 4500,
    inStock: true,
    description: `A comprehensive supplement stack designed to support healthy aging and longevity through targeted nutritional support.`,
    benefits: [
      'Supports healthy aging',
      'Promotes cellular health',
      'Aids energy levels',
      'Supports overall wellness'
    ],
    dosage: [
      'Follow label instructions',
      'Use as part of daily routine'
    ],
    additionalInfo: {
      category: 'Supplement',
      form: 'Capsules'
    },
    addons: []
  },
  'sleep-stack': {
    id: 'sleep-stack',
    name: 'Sleep Stack',
    brand: 'Life Reversal',
    price: '₹3,200',
    priceNum: 3200,
    inStock: true,
    description: `A targeted supplement stack designed to support healthy sleep patterns and recovery.`,
    benefits: [
      'Supports sleep quality',
      'Promotes relaxation',
      'Aids recovery',
      'Supports natural sleep cycles'
    ],
    dosage: [
      'Take before bedtime',
      'Follow label instructions'
    ],
    additionalInfo: {
      category: 'Supplement',
      form: 'Capsules'
    },
    addons: []
  },
  'brain-stack': {
    id: 'brain-stack',
    name: 'Brain Stack',
    brand: 'Life Reversal',
    price: '₹3,800',
    priceNum: 3800,
    inStock: true,
    description: `A cognitive support stack designed to support focus, memory, and mental clarity.`,
    benefits: [
      'Supports cognitive function',
      'Promotes focus',
      'Aids memory',
      'Supports mental clarity'
    ],
    dosage: [
      'Take in the morning',
      'Follow label instructions'
    ],
    additionalInfo: {
      category: 'Supplement',
      form: 'Capsules'
    },
    addons: []
  },
  'gut-stack': {
    id: 'gut-stack',
    name: 'Gut Stack',
    brand: 'Life Reversal',
    price: '₹2,900',
    priceNum: 2900,
    inStock: true,
    description: `A digestive support stack designed to support gut health and microbiome balance.`,
    benefits: [
      'Supports gut health',
      'Promotes digestion',
      'Aids microbiome balance',
      'Supports nutrient absorption'
    ],
    dosage: [
      'Take with meals',
      'Follow label instructions'
    ],
    additionalInfo: {
      category: 'Supplement',
      form: 'Capsules'
    },
    addons: []
  },
  'energy-stack': {
    id: 'energy-stack',
    name: 'Energy Stack',
    brand: 'Life Reversal',
    price: '₹3,500',
    priceNum: 3500,
    inStock: true,
    description: `A performance stack designed to support sustained energy and vitality throughout the day.`,
    benefits: [
      'Supports energy levels',
      'Promotes endurance',
      'Aids performance',
      'Supports vitality'
    ],
    dosage: [
      'Take in the morning',
      'Follow label instructions'
    ],
    additionalInfo: {
      category: 'Supplement',
      form: 'Capsules'
    },
    addons: []
  },
  'diet-fuel-cocoa': {
    id: 'diet-fuel-cocoa',
    name: 'Diet Fuel Cocoa',
    brand: 'Life Reversal',
    price: '₹455',
    priceNum: 455,
    inStock: true,
    description: `A nutrition shake designed to support healthy eating habits with rich cocoa flavor.`,
    benefits: [
      'Supports nutrition',
      'Promotes satiety',
      'Great taste',
      'Easy to prepare'
    ],
    dosage: [
      'Mix with water or milk',
      'Use as meal replacement'
    ],
    additionalInfo: {
      category: 'Diet Fuel',
      form: 'Powder'
    },
    addons: []
  },
  'diet-fuel-coconut': {
    id: 'diet-fuel-coconut',
    name: 'Diet Fuel Coconut Macadamia',
    brand: 'Life Reversal',
    price: '₹600',
    priceNum: 600,
    inStock: true,
    description: `A nutrition shake with tropical coconut macadamia flavor for healthy eating habits.`,
    benefits: [
      'Supports nutrition',
      'Promotes satiety',
      'Tropical flavor',
      'Easy to prepare'
    ],
    dosage: [
      'Mix with water or milk',
      'Use as meal replacement'
    ],
    additionalInfo: {
      category: 'Diet Fuel',
      form: 'Powder'
    },
    addons: []
  },
  'magnesium-glycinate': {
    id: 'magnesium-glycinate',
    name: 'Magnesium Glycinate',
    brand: 'Carbamide Forte',
    price: '₹500',
    priceNum: 500,
    inStock: true,
    isPeptide: false,
    description: `Magnesium Glycinate by Carbamide Forte is a highly bioavailable form of magnesium designed for optimal absorption and minimal digestive discomfort. It supports sleep quality, muscle recovery, nervous system regulation, and metabolic balance.

A foundational supplement for recovery, stress control, and daily performance.`,
    benefits: [
      'Improves sleep quality',
      'Supports muscle relaxation',
      'Reduces stress and nervous system load',
      'Enhances recovery',
      'Supports metabolic balance'
    ],
    dosage: [
      '1\u20132 tablets daily',
      'Preferably in the evening'
    ],
    additionalInfo: {
      form: 'Magnesium Glycinate',
      'elemental magnesium': '440mg',
      'serving size': '2 tablets',
      total: '120 tablets'
    },
    addons: [
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Get expert guidance for your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'mots-c': {
    id: 'mots-c',
    name: 'MOTS-C',
    brand: 'Toro Pharma',
    price: '₹7,500',
    priceNum: 7500,
    inStock: true,
    variants: [
      { key: '25mg', name: '25 mg', label: '25 mg', price: '₹7,500', priceNum: 7500 },
      { key: '10mg', name: '10 mg', label: '10 mg', price: '₹4,500', priceNum: 4500 }
    ],
    description: `MOTS-C is a mitochondrial-derived peptide that plays a critical role in metabolic regulation and cellular energy optimization. It supports glucose metabolism, enhances insulin sensitivity, and improves energy utilization at the cellular level.

Within structured longevity protocols, MOTS-C is used to enhance metabolic flexibility, support fat metabolism, and optimize mitochondrial performance.`,
    benefits: [
      'Enhances mitochondrial efficiency',
      'Supports metabolic flexibility',
      'Improves energy utilization',
      'Supports fat metabolism',
      'Optimizes cellular performance'
    ],
    dosage: [
      'Dosage varies based on protocol goals and should be aligned with structured guidance for metabolic and performance optimization.'
    ],
    additionalInfo: {
      form: 'Lyophilized Peptide',
      administration: 'Subcutaneous',
      storage: 'Refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'aod-9604': {
    id: 'aod-9604',
    name: 'AOD-9604',
    brand: 'Toro Pharma',
    price: '₹3,000',
    priceNum: 3000,
    inStock: true,
    description: `AOD-9604 is a modified fragment of human growth hormone (HGH 176–191) designed to support fat metabolism. It focuses on lipolysis (fat breakdown) without affecting growth hormone pathways or blood sugar levels.`,
    benefits: [
      'Supports breakdown of stored fat',
      'Helps target stubborn fat areas',
      'Supports healthy lipid metabolism',
      'Does not promote muscle growth',
      'Focused fat-loss mechanism'
    ],
    dosage: [
      '300–500 mcg daily',
      'Cycle duration: 8–12 weeks',
      'Best taken in the morning (fasted state)',
      'Administered subcutaneously'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'bioglutide': {
    id: 'bioglutide',
    name: 'BIOGLUTIDE',
    brand: 'Toro Pharma',
    price: '₹12,000',
    priceNum: 12000,
    inStock: true,
    description: `Bioglutide is a GLP-1 pathway-based peptide designed to support appetite regulation, blood sugar balance, and metabolic efficiency. It works by influencing satiety signals and slowing gastric emptying, helping reduce calorie intake and improve metabolic control.`,
    benefits: [
      'Supports appetite control and satiety',
      'Helps reduce excess body fat',
      'Supports blood sugar regulation',
      'Promotes metabolic efficiency',
      'May assist in sustainable weight management'
    ],
    dosage: [
      'Starting dose: 0.25–0.5 mg weekly',
      'Gradually increase to 1.0 mg or higher based on tolerance',
      'Administered once weekly',
      'Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'dsip': {
    id: 'dsip',
    name: 'DSIP',
    brand: 'Toro Pharma',
    price: '₹4,000',
    priceNum: 4000,
    inStock: true,
    description: `DSIP (Delta Sleep-Inducing Peptide) is a neuropeptide known for its role in supporting sleep regulation and stress balance. It may help improve sleep quality by influencing natural sleep cycles and calming the nervous system.`,
    benefits: [
      'Supports deeper and more restful sleep',
      'Helps reduce sleep latency (time to fall asleep)',
      'Supports stress regulation',
      'May assist in balancing cortisol levels',
      'Promotes overall recovery and relaxation'
    ],
    dosage: [
      'Typical: 100–300 mcg nightly',
      'Cycle: 2–4 weeks',
      'Best taken: 30–60 minutes before bedtime',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'kisspeptin': {
    id: 'kisspeptin',
    name: 'KISSPEPTIN',
    brand: 'Toro Pharma',
    price: '₹8,000',
    priceNum: 8000,
    inStock: true,
    description: `Kisspeptin is a peptide that plays a key role in regulating reproductive hormones by stimulating the release of gonadotropin-releasing hormone (GnRH). It supports hormonal balance, fertility function, and overall reproductive health in both men and women.`,
    benefits: [
      'Supports natural testosterone production (men)',
      'Supports fertility and reproductive function',
      'Enhances libido and sexual health',
      'Helps regulate hormonal signaling pathways',
      'Supports endocrine system balance'
    ],
    dosage: [
      'Typical: 100–500 mcg per dose',
      'Frequency: 1–3 times per week (protocol dependent)',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'll-37': {
    id: 'll-37',
    name: 'LL-37',
    brand: 'Toro Pharma',
    price: '₹4,000',
    priceNum: 4000,
    inStock: true,
    description: `LL-37 is an antimicrobial peptide involved in the body's innate immune response. It supports immune defense, inflammation balance, and tissue repair processes, making it valuable for recovery and regenerative support.`,
    benefits: [
      'Supports immune system function',
      'Helps balance inflammation response',
      'Supports skin repair and recovery',
      'Promotes tissue regeneration',
      'Supports gut barrier integrity'
    ],
    dosage: [
      'Typical: 100–500 mcg per day',
      'Cycle: 2–4 weeks',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'selank': {
    id: 'selank',
    name: 'SELANK',
    brand: 'Toro Pharma',
    price: '₹4,000',
    priceNum: 4000,
    inStock: true,
    description: `Selank is a synthetic peptide known for its effects on anxiety reduction, mood stabilization, and cognitive function. It works by modulating neurotransmitters such as serotonin and dopamine, helping promote calm focus without sedation.`,
    benefits: [
      'Supports reduction in anxiety and stress',
      'Promotes calm, focused mental state',
      'Supports mood regulation',
      'May enhance cognitive performance',
      'Supports immune system modulation'
    ],
    dosage: [
      'Typical: 250–500 mcg per dose',
      'Frequency: 1–3 times daily',
      'Cycle: 10–14 days (can extend based on protocol)',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'semax': {
    id: 'semax',
    name: 'SEMAX',
    brand: 'Toro Pharma',
    price: '₹5,000',
    priceNum: 5000,
    inStock: true,
    description: `Semax is a nootropic peptide known for its effects on cognitive function, memory, and mental performance. It supports brain-derived neurotrophic factor (BDNF) activity and helps enhance focus, learning, and resilience under stress.`,
    benefits: [
      'Supports cognitive enhancement and mental clarity',
      'Improves memory and learning capacity',
      'Enhances focus and concentration',
      'Supports performance under stress',
      'May support neuroprotection'
    ],
    dosage: [
      'Typical: 300–600 mcg per dose',
      'Frequency: 1–3 times daily',
      'Cycle: 10–14 days',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'slu-pp-332': {
    id: 'slu-pp-332',
    name: 'SLU-PP-332',
    brand: 'Toro Pharma',
    price: '₹5,000',
    priceNum: 5000,
    inStock: true,
    description: `SLU-PP-332 is a metabolic modulator known for its role in enhancing mitochondrial activity and promoting endurance. It supports fat utilization and energy efficiency, making it valuable for metabolic performance and physical output.`,
    benefits: [
      'Supports enhanced fat utilization',
      'Improves endurance and stamina',
      'Supports mitochondrial biogenesis',
      'Enhances metabolic flexibility',
      'Supports sustained energy output'
    ],
    dosage: [
      'Typical: 250–500 mcg per dose',
      'Frequency: Twice daily',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized compound',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'ss-31': {
    id: 'ss-31',
    name: 'SS-31',
    brand: 'Toro Pharma',
    price: '₹5,500',
    priceNum: 5500,
    inStock: true,
    description: `SS-31 is a mitochondria-targeting peptide designed to support cellular energy production and reduce oxidative stress. It works by improving mitochondrial efficiency, helping enhance endurance, recovery, and overall cellular performance.`,
    benefits: [
      'Supports mitochondrial function and efficiency',
      'Enhances cellular energy output',
      'Supports cardiovascular cellular health',
      'Improves muscle endurance and recovery',
      'Helps reduce oxidative stress'
    ],
    dosage: [
      'Typical: 2–5 mg per day',
      'Frequency: Once daily',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'vilon': {
    id: 'vilon',
    name: 'VILON',
    brand: 'Toro Pharma',
    price: '₹5,300',
    priceNum: 5300,
    inStock: true,
    description: `Vilon is a peptide known for its role in supporting immune system function and cellular regulation. It is often used to promote resilience, stress adaptation, and overall vitality.`,
    benefits: [
      'Supports immune system function',
      'Helps improve stress adaptation',
      'Supports metabolic regulation',
      'Promotes overall vitality and resilience',
      'Supports cellular health'
    ],
    dosage: [
      'Typical: 5–10 mg per day',
      'Cycle: 10–20 days',
      'Administration: Subcutaneous or intramuscular injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'vip': {
    id: 'vip',
    name: 'VIP',
    brand: 'Toro Pharma',
    price: '₹5,300',
    priceNum: 5300,
    inStock: true,
    description: `VIP (Vasoactive Intestinal Peptide) is a regulatory peptide involved in gut-brain signaling, immune modulation, and nervous system balance. It is used to support inflammation control, gut function, and overall neuroimmune regulation.`,
    benefits: [
      'Supports gut-brain axis regulation',
      'Helps maintain a healthy inflammatory response',
      'Supports autonomic nervous system balance',
      'Promotes gut function and integrity',
      'Supports neuroimmune signaling'
    ],
    dosage: [
      '500 mcg per dose',
      'Twice daily (total ~1 mg/day)',
      'Administration: Subcutaneous injection'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'retatrutide': {
    id: 'retatrutide',
    name: 'RETATRUTIDE',
    brand: 'Toro Pharma',
    price: '₹12,000',
    priceNum: 12000,
    inStock: true,
    variants: [
      { key: '20mg', name: '20 mg', label: '20 mg', price: '₹12,000', priceNum: 12000 },
      { key: '10mg', name: '10 mg', label: '10 mg', price: '₹6,500', priceNum: 6500 }
    ],
    description: `Retatrutide is an advanced multi-receptor peptide designed to support fat loss, appetite control, and metabolic optimization. It works by targeting key pathways involved in energy balance, helping improve body composition and metabolic efficiency.`,
    benefits: [
      'Supports fat loss and body composition',
      'Helps regulate appetite and cravings',
      'Supports metabolic efficiency',
      'May improve insulin sensitivity',
      'Supports long-term weight management'
    ],
    dosage: [
      'Typically administered once weekly',
      'Starting dose varies based on protocol',
      'Gradual titration recommended',
      'Administered subcutaneously'
    ],
    additionalInfo: {
      form: 'Lyophilized peptide',
      quality: 'Sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'revigen': {
    id: 'revigen',
    name: 'REVIGEN',
    brand: 'Toro Pharma',
    price: '₹13,000',
    priceNum: 13000,
    inStock: true,
    description: `Revigen is an advanced multi-peptide regenerative complex designed for skin repair, anti-aging, and hair support. It works at a cellular level to enhance collagen production, accelerate tissue healing, and improve scalp and follicle health—helping you achieve healthier skin and stronger hair from within.`,
    benefits: [
      'Promotes collagen production for firmer, youthful skin',
      'Supports skin repair and reduces signs of aging',
      'Enhances skin texture, glow, and elasticity',
      'Helps reduce inflammation and skin irritation',
      'Supports acne-prone skin and helps reduce breakouts (KPV support)',
      'Supports scalp health and hair follicle strength',
      'May improve hair thickness and reduce hair fall',
      'Accelerates wound healing and tissue recovery',
      'Supports overall cellular regeneration'
    ],
    dosage: [
      'BPC-157: 200–500 mcg daily',
      'TB-500: 2–5 mg weekly (split doses)',
      'KPV: 200–500 mcg daily',
      'GHK-Cu: 1–2 mg several times per week',
      'Cycle: 4–8 weeks'
    ],
    additionalInfo: {
      form: '80 mg peptide blend',
      quality: 'Lyophilized powder, sterile, pyrogen-free',
      storage: 'Store refrigerated'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'glow': {
    id: 'glow',
    name: 'GLOW',
    brand: 'Toro Pharma',
    price: '₹10,500',
    priceNum: 10500,
    inStock: true,
    description: `Glow is a powerful multi-peptide blend designed to support skin rejuvenation, collagen production, and hair health. It works at a cellular level to repair tissue, improve elasticity, and enhance overall skin radiance while also supporting stronger and healthier hair growth.`,
    benefits: [
      'Boosts collagen production for firmer, youthful skin',
      'Enhances skin glow, texture, and elasticity',
      'Supports skin repair and reduces signs of aging',
      'Helps reduce inflammation and skin damage',
      'Promotes healthier scalp and hair follicles',
      'Supports hair strength and thickness',
      'Accelerates tissue recovery and regeneration'
    ],
    dosage: [
      'BPC-157: 250–500 mcg daily',
      'GHK-CU: 2–3 mg daily (subcutaneous)',
      'TB-500: 2–2.5 mg, twice weekly (loading phase)'
    ],
    additionalInfo: {
      form: '60 mg peptide blend',
      quality: 'Lyophilized powder, sterile, pyrogen-free',
      storage: 'Store refrigerated after reconstitution'
    },
    addons: [
      { id: 'bac-water', name: 'Bacteriostatic Water', price: '₹500', type: 'product' },
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'bpc157-tb500-tablets': {
    id: 'bpc157-tb500-tablets',
    name: 'BPC 157 + TB500',
    brand: 'Toro Pharma',
    price: '₹5,850',
    priceNum: 5850,
    inStock: true,
    description: `BPC 157 + TB500 is a convenient oral peptide-based supplement designed to support recovery, reduce inflammation, and promote overall tissue repair. This formulation helps improve mobility, gut health, and recovery without the need for injections.`,
    benefits: [
      'Accelerated tissue repair and recovery',
      'Supports joint and ligament health',
      'Helps reduce inflammation',
      'Enhances gut health and digestive support',
      'Promotes faster post-workout recovery',
      'Supports mobility and physical performance'
    ],
    dosage: [
      'Serving Size: 1 tablet',
      'Strength: 1 mg per tablet',
      'Daily Intake: 2 mg per day',
      'Directions: Take 1 tablet twice daily'
    ],
    additionalInfo: {
      form: '60 tablets per bottle',
      quality: 'Oral supplement format, easy to use (no injections)',
      storage: 'Store in a cool, dry place'
    },
    addons: [
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'gnc-fish-oil': {
    id: 'gnc-fish-oil',
    name: 'GNC Fish Oil 1000 mg',
    brand: 'GNC',
    price: '₹599',
    priceNum: 599,
    inStock: true,
    description: `GNC Fish Oil 1000 mg is a high-quality omega-3 supplement designed to support heart, brain, and joint health. It delivers essential fatty acids EPA and DHA that play a key role in overall wellness, skin hydration, and cognitive function.`,
    benefits: [
      'Supports heart health',
      'Promotes brain function and focus',
      'Helps improve joint flexibility',
      'Supports healthy skin and hydration',
      'Aids in reducing muscle soreness',
      'Supports overall wellness'
    ],
    dosage: [
      'Serving Size: 1 softgel',
      'Recommended: 1–2 softgels daily after meals'
    ],
    additionalInfo: {
      form: '90 softgel capsules',
      quality: 'Omega-3 (EPA + DHA), no heavy metals, no fishy burps',
      storage: 'Store in a cool, dry place'
    },
    addons: [
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  },
  'bac-water': {
    id: 'bac-water',
    name: 'Bacteriostatic Water 10ml',
    brand: 'Toro Pharma',
    price: '₹600',
    priceNum: 600,
    inStock: true,
    description: `Bacteriostatic Water 10ml is a sterile, multi-dose solution containing 0.9% benzyl alcohol, designed for reconstituting peptide compounds. It helps maintain solution integrity and prevents bacterial growth for safe multi-use.`,
    benefits: [
      'Maintains sterility of peptide solutions',
      'Supports multi-dose usage',
      'Inhibits bacterial growth',
      'Ensures peptide stability after mixing',
      'Reduces contamination risk',
      'Essential for peptide reconstitution'
    ],
    dosage: [
      'Used for reconstitution of lyophilized peptides',
      'Not for direct standalone injection',
      'Multi-dose vial (usable up to ~28 days after opening)'
    ],
    additionalInfo: {
      form: 'Volume: 10ml',
      quality: 'Benzyl Alcohol: 0.9%, Sterile & Pyrogen-Free',
      storage: 'Multidose vial'
    },
    addons: [
      { id: 'protocol-guidance', name: 'Protocol Guidance', subtext: 'Structured guidance aligned to your protocol', type: 'link', link: 'https://lifereversal.in', linkText: 'Book Call' }
    ]
  }
};

// Related Products
const RELATED_PRODUCTS = [
  { id: 'ghk-cu', name: 'GHK-Cu', brand: 'Toro Pharma', price: '₹12,000', image: PRODUCT_IMAGES['ghk-cu']?.main },
  { id: 'nad-plus', name: 'NAD+', brand: 'Toro Pharma', price: '₹5,500', image: PRODUCT_IMAGES['nad-plus']?.main },
  { id: 'tb500', name: 'TB500', brand: 'Toro Pharma', price: '₹7,000', image: PRODUCT_IMAGES['tb500']?.main },
  { id: 'mots-c', name: 'MOTS-C', brand: 'Toro Pharma', price: '₹7,500', image: PRODUCT_IMAGES['mots-c']?.main },
  { id: 'aod-9604', name: 'AOD-9604', brand: 'Toro Pharma', price: '₹3,000', image: PRODUCT_IMAGES['aod-9604']?.main },
  { id: 'bioglutide', name: 'BIOGLUTIDE', brand: 'Toro Pharma', price: '₹12,000', image: PRODUCT_IMAGES['bioglutide']?.main },
  { id: 'dsip', name: 'DSIP', brand: 'Toro Pharma', price: '₹4,000', image: PRODUCT_IMAGES['dsip']?.main },
  { id: 'kisspeptin', name: 'KISSPEPTIN', brand: 'Toro Pharma', price: '₹8,000', image: PRODUCT_IMAGES['kisspeptin']?.main },
  { id: 'll-37', name: 'LL-37', brand: 'Toro Pharma', price: '₹4,000', image: PRODUCT_IMAGES['ll-37']?.main },
  { id: 'selank', name: 'SELANK', brand: 'Toro Pharma', price: '₹4,000', image: PRODUCT_IMAGES['selank']?.main },
  { id: 'semax', name: 'SEMAX', brand: 'Toro Pharma', price: '₹5,000', image: PRODUCT_IMAGES['semax']?.main },
  { id: 'slu-pp-332', name: 'SLU-PP-332', brand: 'Toro Pharma', price: '₹5,000', image: PRODUCT_IMAGES['slu-pp-332']?.main },
  { id: 'ss-31', name: 'SS-31', brand: 'Toro Pharma', price: '₹5,500', image: PRODUCT_IMAGES['ss-31']?.main },
  { id: 'vilon', name: 'VILON', brand: 'Toro Pharma', price: '₹5,300', image: PRODUCT_IMAGES['vilon']?.main },
  { id: 'vip', name: 'VIP', brand: 'Toro Pharma', price: '₹5,300', image: PRODUCT_IMAGES['vip']?.main },
  { id: 'retatrutide', name: 'RETATRUTIDE', brand: 'Toro Pharma', price: '₹12,000', image: PRODUCT_IMAGES['retatrutide']?.main },
  { id: 'revigen', name: 'REVIGEN', brand: 'Toro Pharma', price: '₹13,000', image: PRODUCT_IMAGES['revigen']?.main },
  { id: 'glow', name: 'GLOW', brand: 'Toro Pharma', price: '₹10,500', image: PRODUCT_IMAGES['glow']?.main },
  { id: 'bpc157-tb500-tablets', name: 'BPC 157 + TB500', brand: 'Toro Pharma', price: '₹5,850', image: PRODUCT_IMAGES['bpc157-tb500-tablets']?.main },
  { id: 'gnc-fish-oil', name: 'GNC Fish Oil 1000 mg', brand: 'GNC', price: '₹599', image: PRODUCT_IMAGES['gnc-fish-oil']?.main },
  { id: 'bac-water', name: 'Bacteriostatic Water 10ml', brand: 'Toro Pharma', price: '₹600', image: PRODUCT_IMAGES['bac-water']?.main },
];

const AccordionItem = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <div style={{ borderBottom: '1px solid #E8E6E1' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-4 text-left"
      >
        <span 
          className="text-sm font-medium"
          style={{ color: '#2B2B2B' }}
        >
          {title}
        </span>
        <ChevronDown 
          size={18} 
          style={{ 
            color: '#6B6B6B',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
            transition: 'transform 0.2s'
          }} 
        />
      </button>
      {isOpen && (
        <div className="pb-4">
          {children}
        </div>
      )}
    </div>
  );
};

export const ProductPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  
  const product = PRODUCTS[productId] || PRODUCTS['bpc-157'];
  const images = PRODUCT_IMAGES[productId] || PRODUCT_IMAGES['bpc-157'];
  
  const [selectedImage, setSelectedImage] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(0);

  // Variant-aware computed values
  const hasVariants = product.variants && product.variants.length > 0;
  const activeVariant = hasVariants ? product.variants[selectedVariant] : null;
  const activePrice = activeVariant ? activeVariant.price : product.price;
  const activeGallery = (hasVariants && images.variants && activeVariant)
    ? (images.variants[activeVariant.key] || images.gallery || [])
    : (images.gallery || []);

  // Scroll to top and reset state on page load
  useEffect(() => {
    window.scrollTo(0, 0);
    setSelectedVariant(0);
    setSelectedImage(0);
    setPreviewImage(null);
    setQuantity(1);
    setSelectedAddons([]);
  }, [productId]);

  const currentImage = previewImage !== null ? previewImage : selectedImage;

  const handleAddToCart = () => {
    const cartId = hasVariants ? `${product.id}-${activeVariant.key}` : product.id;
    const cartName = hasVariants ? `${product.name} (${activeVariant.label})` : product.name;
    const cartPrice = activePrice;
    const cartImage = activeGallery[0] || images.main;

    addToCart({
      id: cartId,
      name: cartName,
      brand: product.brand,
      price: cartPrice,
      image: cartImage
    }, quantity);
    
    // Add selected addons
    selectedAddons.forEach(addonId => {
      const addon = product.addons.find(a => a.id === addonId);
      if (addon && addon.type !== 'link') {
        addToCart({
          id: addon.id,
          name: addon.name,
          brand: 'Add-on',
          price: addon.price,
          image: null
        }, 1);
      }
    });
  };

  const toggleAddon = (addonId) => {
    setSelectedAddons(prev => 
      prev.includes(addonId) 
        ? prev.filter(id => id !== addonId)
        : [...prev, addonId]
    );
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F2EB' }}>
      <ValuePropositionBanner />
      <Header />
      
      {/* Product Section */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-20">
        {/* Back Button */}
        <button
          onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')}
          className="flex items-center gap-1.5 text-sm font-medium mb-8 hover:opacity-70 transition-opacity"
          style={{ color: '#2B2B2B' }}
          data-testid="back-button"
        >
          <ArrowLeft size={16} strokeWidth={1.5} />
          Back
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          
          {/* Left - Product Images */}
          <div>
            {/* Main Image */}
            <div 
              className="w-full mb-4 flex items-center justify-center overflow-hidden"
              style={{ backgroundColor: '#F5F2EB', height: '420px', padding: '24px' }}
            >
              {activeGallery[currentImage] ? (
                <picture style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                  <source srcSet={activeGallery[currentImage].replace(/\.(png|jpg|jpeg|PNG)$/i, '.webp')} type="image/webp" />
                  <img 
                    src={activeGallery[currentImage]}
                    alt={product.name}
                    className="max-w-full max-h-full"
                    style={{ objectFit: 'contain', objectPosition: 'center', maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', filter: 'drop-shadow(0 6px 18px rgba(0,0,0,0.08))' }}
                    data-testid="main-product-image"
                  />
                </picture>
              ) : (
                <div className="w-full h-full" style={{ backgroundColor: '#F0EEE9' }} />
              )}
            </div>

            {/* Thumbnails */}
            {activeGallery.length > 1 && (
              <div className="flex gap-3 overflow-x-auto pb-1">
                {activeGallery.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setSelectedImage(idx)}
                    onMouseEnter={() => setPreviewImage(idx)}
                    onMouseLeave={() => setPreviewImage(null)}
                    className="w-[72px] h-[72px] flex-shrink-0 transition-all duration-200 p-2"
                    style={{ 
                      border: selectedImage === idx ? '2px solid #1A3D36' : '1px solid #D9D6CF',
                      backgroundColor: '#F5F2EB',
                      borderRadius: '2px',
                    }}
                    data-testid={`thumbnail-${idx}`}
                  >
                    <picture>
                      <source srcSet={img.replace(/\.(png|jpg|jpeg|PNG)$/i, '.webp')} type="image/webp" />
                      <img 
                        src={img}
                        alt={`${product.name} view ${idx + 1}`}
                        loading="lazy"
                        className="w-full h-full"
                        style={{ objectFit: 'contain', objectPosition: 'center' }}
                      />
                    </picture>
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Right - Product Info */}
          <div className="lg:pt-0">
            {/* Brand */}
            <p 
              className="text-xs font-medium uppercase tracking-wider mb-1.5"
              style={{ color: '#6B6B6B' }}
            >
              {product.brand}
            </p>

            {/* Title */}
            <h1 
              className="font-serif text-3xl lg:text-4xl mb-3"
              style={{ color: '#2B2B2B' }}
            >
              {product.name}
            </h1>

            {/* Price */}
            <p 
              className="text-2xl font-semibold mb-2"
              style={{ color: '#2B2B2B' }}
              data-testid="product-price"
            >
              {activePrice}
            </p>

            {/* Stock */}
            <p 
              className="text-sm mb-5"
              style={{ color: product.inStock ? '#1A3D36' : '#B54848' }}
            >
              {product.inStock ? 'In stock' : 'Out of stock'}
            </p>

            {/* Variant Selector */}
            {hasVariants && (
              <div className="mb-6">
                <p 
                  className="text-xs font-medium uppercase tracking-wider mb-2"
                  style={{ color: '#6B6B6B' }}
                >
                  Variant
                </p>
                <select
                  value={selectedVariant}
                  onChange={(e) => {
                    setSelectedVariant(Number(e.target.value));
                    setSelectedImage(0);
                    setPreviewImage(null);
                  }}
                  className="w-full py-3 px-4 text-sm appearance-none cursor-pointer"
                  style={{ 
                    border: '1px solid #D9D6CF', 
                    backgroundColor: '#FFFFFF',
                    color: '#2B2B2B',
                    borderRadius: '4px',
                    outline: 'none'
                  }}
                  data-testid="variant-selector"
                >
                  {product.variants.map((v, idx) => (
                    <option key={v.key} value={idx}>
                      {v.name} — {v.price}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Peptide Calculator Link */}
            {product.isPeptide !== false && (
            <a
              href="https://lifereversal.in"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm underline mb-8 inline-block hover:opacity-70 transition-opacity"
              style={{ color: '#1A3D36' }}
            >
              Peptide Calculator
            </a>
            )}

            {/* Quantity Selector */}
            <div className="mb-6">
              <p 
                className="text-xs font-medium uppercase tracking-wider mb-2"
                style={{ color: '#6B6B6B' }}
              >
                Quantity
              </p>
              <div 
                className="inline-flex items-center"
                style={{ border: '1px solid #D9D6CF' }}
              >
                <button 
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="p-3 hover:bg-gray-50 transition-colors"
                  data-testid="qty-decrease"
                >
                  <Minus size={16} style={{ color: '#2B2B2B' }} />
                </button>
                <span 
                  className="text-sm font-medium w-12 text-center"
                  style={{ color: '#2B2B2B' }}
                >
                  {quantity}
                </span>
                <button 
                  onClick={() => setQuantity(quantity + 1)}
                  className="p-3 hover:bg-gray-50 transition-colors"
                  data-testid="qty-increase"
                >
                  <Plus size={16} style={{ color: '#2B2B2B' }} />
                </button>
              </div>
            </div>

            {/* Add to Cart */}
            <button
              onClick={handleAddToCart}
              className="w-full py-4 text-sm font-medium transition-all duration-200 hover:opacity-90 mb-3"
              style={{ 
                backgroundColor: '#1A3D36', 
                color: '#FFFFFF',
                borderRadius: '4px'
              }}
              data-testid="add-to-cart"
            >
              Add to Cart
            </button>

            {/* WhatsApp Protocol Guidance */}
            <button
              type="button"
              onClick={() => {
                const variantLabel = hasVariants && activeVariant ? ` ${activeVariant.label}` : '';
                openWhatsApp(WHATSAPP_MESSAGES.product(`${product.name}${variantLabel}`));
              }}
              className="w-full py-3.5 text-sm font-medium transition-all duration-200 hover:opacity-80 mb-8"
              style={{ 
                backgroundColor: 'transparent', 
                color: '#1A3D36',
                border: '1px solid #1A3D36',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              data-testid="product-whatsapp-btn"
            >
              Get Guidance on This Protocol
            </button>

            {/* Optional Add-on */}
            {product.addons && product.addons.length > 0 && (
              <div className="mb-8" style={{ borderTop: '1px solid #E8E6E1', paddingTop: '16px' }}>
                <p 
                  className="text-xs font-medium uppercase tracking-wider mb-3"
                  style={{ color: '#6B6B6B' }}
                >
                  Optional
                </p>
                <div className="space-y-3">
                  {product.addons.map(addon => (
                    addon.type === 'link' ? (
                      <div key={addon.id} className="flex items-start gap-3">
                        <div>
                          <span 
                            className="text-sm font-medium block"
                            style={{ color: '#2B2B2B' }}
                          >
                            {addon.name}
                          </span>
                          {addon.subtext && (
                            <span 
                              className="text-xs block mt-0.5"
                              style={{ color: '#6B6B6B' }}
                            >
                              {addon.subtext}
                            </span>
                          )}
                          <a
                            href={addon.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm font-medium underline inline-block mt-1 hover:opacity-70 transition-opacity"
                            style={{ color: '#1A3D36' }}
                            data-testid={`addon-link-${addon.id}`}
                          >
                            {addon.linkText}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <label 
                        key={addon.id}
                        className="flex items-center gap-3 cursor-pointer py-1"
                      >
                        <input
                          type="checkbox"
                          checked={selectedAddons.includes(addon.id)}
                          onChange={() => toggleAddon(addon.id)}
                          className="w-4 h-4 accent-[#1A3D36] flex-shrink-0"
                        />
                        <span 
                          className="text-sm"
                          style={{ color: '#2B2B2B' }}
                        >
                          {addon.name} ({addon.price})
                        </span>
                      </label>
                    )
                  ))}
                </div>
              </div>
            )}

            {/* Accordion - Product Details */}
            <div>
              <AccordionItem title="Description" defaultOpen>
                <p 
                  className="text-sm leading-relaxed whitespace-pre-line"
                  style={{ color: '#6B6B6B' }}
                >
                  {product.description}
                </p>
              </AccordionItem>

              <AccordionItem title="Benefits">
                <ul className="space-y-2">
                  {product.benefits.map((benefit, idx) => (
                    <li 
                      key={idx}
                      className="text-sm flex items-start gap-2"
                      style={{ color: '#6B6B6B' }}
                    >
                      <span style={{ color: '#1A3D36' }}>•</span>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </AccordionItem>

              <AccordionItem title="Dosage">
                <ul className="space-y-2">
                  {product.dosage.map((item, idx) => (
                    <li 
                      key={idx}
                      className="text-sm flex items-start gap-2"
                      style={{ color: '#6B6B6B' }}
                    >
                      <span style={{ color: '#1A3D36' }}>•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </AccordionItem>

              <AccordionItem title="Additional Information">
                <div className="space-y-2">
                  {Object.entries(product.additionalInfo).map(([key, value]) => (
                    <div key={key} className="flex gap-4">
                      <span 
                        className="text-sm capitalize"
                        style={{ color: '#6B6B6B' }}
                      >
                        {key}:
                      </span>
                      <span 
                        className="text-sm"
                        style={{ color: '#2B2B2B' }}
                      >
                        {value}
                      </span>
                    </div>
                  ))}
                </div>
              </AccordionItem>

              <AccordionItem title="Reviews">
                <p 
                  className="text-sm"
                  style={{ color: '#6B6B6B' }}
                >
                  No reviews yet
                </p>
              </AccordionItem>
            </div>

            {/* Medical Disclaimer */}
            <p 
              className="text-[11px] mt-8 leading-relaxed"
              style={{ color: '#8A8A8A' }}
            >
              Consult a healthcare professional before use. Not intended to diagnose, treat, cure, or prevent disease.
            </p>
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section 
        className="py-16 lg:py-20"
        style={{ backgroundColor: '#F5F2EB' }}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <h2 
            className="font-serif text-2xl lg:text-3xl mb-10 text-center"
            style={{ color: '#2B2B2B' }}
          >
            Explore other ways to support your biology.
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {RELATED_PRODUCTS.filter(r => r.id !== productId).slice(0, 8).map(relProduct => (
              <div 
                key={relProduct.id}
                className="group relative bg-white transition-all duration-300 hover:shadow-md cursor-pointer overflow-hidden"
                style={{ borderRadius: '4px' }}
                onClick={() => navigate(`/product/${relProduct.id}`)}
              >
                {/* Brand Label */}
                <div 
                  className="absolute top-2.5 left-2.5 z-10 px-2 py-0.5"
                  style={{ backgroundColor: '#000000', borderRadius: '3px' }}
                >
                  <span className="text-[9px] font-medium uppercase" style={{ color: '#FFFFFF', letterSpacing: '0.06em' }}>
                    {relProduct.brand}
                  </span>
                </div>

                {/* Image */}
                <div 
                  className="w-full flex items-center justify-center overflow-hidden"
                  style={{ backgroundColor: '#F5F2EB', height: '160px', padding: '12px' }}
                >
                  {relProduct.image ? (
                    <picture style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                      <source srcSet={relProduct.image.replace(/\.(png|jpg|jpeg|PNG)$/i, '.webp')} type="image/webp" />
                      <img 
                        src={relProduct.image}
                        alt={relProduct.name}
                        loading="lazy"
                        className="max-w-full max-h-full"
                        style={{ objectFit: 'contain', objectPosition: 'center', maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.06))' }}
                      />
                    </picture>
                  ) : (
                    <div className="w-full h-full" style={{ backgroundColor: '#F0EEE9' }} />
                  )}
                </div>

                {/* Info */}
                <div className="p-3.5">
                  <h3 className="text-sm font-medium mb-1 line-clamp-1" style={{ color: '#2B2B2B' }}>
                    {relProduct.name}
                  </h3>
                  <p className="text-sm font-semibold mb-2" style={{ color: '#2B2B2B' }}>
                    {relProduct.price}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium hover:opacity-70 transition-opacity" style={{ color: '#1A3D36' }}>
                    View Product
                    <ArrowRight size={12} strokeWidth={2} />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductPage;
